import { useRemoveEntityProducts } from '../hooks/use-remove-entity-products'
import { EntityProductsModal } from '../ui'

export const RemoveEntityProductModal = () => {
	const { shouldShowModal, onOk, onCancel } = useRemoveEntityProducts()

	return <EntityProductsModal open={shouldShowModal} onCancel={onCancel} onOk={onOk} />
}
